import api from '../../api'

// Utilities
import Logger from '../../utility/loggerUtil'

export default {
  async getPredictions (context, params) {
    try {
      const response = await api.address.getPredictions(params)
      context.commit('setPredictions', response.predictions)
      return response.predictions
    } catch (e) {
      Logger.error('Error getting address predictions')
      Logger.debug(e)
      throw e
    }
  },

  async getPlaceDetails (context, params) {
    try {
      const response = await api.address.getPlaceDetails(params)
      context.commit('setPlaceDetails', response.details)
      return response.details
    } catch (e) {
      Logger.error('Error getting place details')
      Logger.debug(e)
      throw e
    }
  },

  async getStateOptions (context) {
    try {
      const response = await api.states.getAll()
      context.commit('setAllStateOptions', response)
    } catch (e) {
      Logger.error('Error getting state options')
      Logger.debug(e)
      throw e
    }
  },

  clearAutocompleteData (context) {
    context.commit('clearPredictions')
    context.commit('clearPlaceDetails')
  }
}
